export type ParcelOrderStatus =
  | "PAYMENT_PENDING"
  | "PAYMENT_COMPLETED"
  | "SHIPPING_PREPARATION"
  | "SHIPPED";

export const PARCEL_ORDER_STATUS_LABEL: Record<ParcelOrderStatus, string> = {
  PAYMENT_PENDING: "결제대기",
  PAYMENT_COMPLETED: "결제완료",
  SHIPPING_PREPARATION: "배송준비",
  SHIPPED: "출고완료",
};

export function normalizeParcelOrderStatus(
  raw: string | undefined | null,
): ParcelOrderStatus {
  if (
    raw === "PAYMENT_PENDING" ||
    raw === "PAYMENT_COMPLETED" ||
    raw === "SHIPPING_PREPARATION" ||
    raw === "SHIPPED"
  ) {
    return raw;
  }
  return "PAYMENT_PENDING";
}

export interface ParcelOrder {
  customerName: string;
  address: string;
  detailAddress: string;
  orderNumber: string;
  phoneNumber: string;
  totalPrice: number;
  parcelProducts: OrderProduct[];
  createdAt: Date;
  status: ParcelOrderStatus;
}

interface OrderProduct {
  name: string;
  quantity: number;
  finalPrice: number;
  unitPrice?: number;
  productCode?: string;
}
